import { FaHouse, FaLocationCrosshairs, FaUser, FaBuilding, FaAnglesLeft } from "react-icons/fa6"
import { AiOutlineAppstore } from "react-icons/ai"
import { Navigate } from "react-router-dom"
import { useContext, useEffect, useState } from "react"
import UiContext from "../../context/uiProvider"
import { LARGE_DESKTOP, DESKTOP, LARGE_TABLET, TABLET, MOBILE } from "../../utils/screenSize"
import useUser from "../../hooks/useUser"
import SidebarLink from "./SidebarLink"
import SmallLogo from "../../assets/logo-white-no-background.png"
import Tooltip from "../tooltips/Tooltip"
import { MANAGER, OWNER } from "../../utils/roles"

export default function Sidebar() {
  const { sidebarOpen: open, setSidebarOpen: setOpen, deviceView, setDeviceView } = useContext(UiContext)
  const { roleId } = useUser()
  const [sidebarWidth, setSidebarWidth] = useState("w-20")

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1440) {
        setDeviceView(LARGE_DESKTOP)
        setSidebarWidth("w-64")
      } else if (window.innerWidth >= 1280) {
        setDeviceView(DESKTOP)
        setSidebarWidth("w-64")
      } else if (window.innerWidth > 1024) {
        setDeviceView(LARGE_TABLET)
        setSidebarWidth("w-64")
      } else if (window.innerWidth >= 768) {
        setDeviceView(TABLET)
        setSidebarWidth("w-56")
      } else {
        setDeviceView(MOBILE)
        setSidebarWidth("w-14")
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    // unmount
    return () => window.removeEventListener("resize", handleResize)
  }, [setDeviceView])

  // repeated class for transitions when expanding and collapsing sidebar
  const transitionLink = `transition-opacity ease-in ${open ? "duration-700 opacity-100 pl-3 text-lg" : "duration-100 opacity-0 w-0 p-0 absolute overflow-hidden"}`

  if (!roleId) return <Navigate to={"/login"} replace />

  return (
    <div className={`h-screen z-20 max-h-screen`}>
      <div className={`bg-primary-dark relative ease-in duration-300 text-white h-full shadow-right-lg ${deviceView < MOBILE ? "w-14 pt-" : `${open ? sidebarWidth : "w-20"} text-xl`}`}>
        <div className={`w-full flex justify-center px-10 py-6 ${!open && "invisible"}`}>
          <img src={SmallLogo} alt="logo" />
        </div>
        {deviceView >= TABLET && <FaAnglesLeft className={`text-white z-30 text-3xl -right-3 absolute top-9 bg-primary-dark ease-in duration-300 rounded-full p-1 ${!open && "rotate-180"}`} onClick={() => setOpen(!open)} />}

        <SidebarLink to={"/app/" as "dashboard"}>
          <Tooltip text="Open Dashboard">
            <FaHouse className="text-3xl" />
          </Tooltip>
          {deviceView >= TABLET && (
            <Tooltip text="Drag tables to change order">
              <span className={transitionLink}>Dashboard</span>
            </Tooltip>
          )}
        </SidebarLink>
        {roleId > OWNER && (
          <SidebarLink to={"/app/management-companies"}>
            <Tooltip text="View Management Companies">
              <FaBuilding className="text-3xl" />
            </Tooltip>
            {deviceView >= TABLET && (
              <Tooltip text="View and manage companies">
                <div className={transitionLink}>
                  <div>Management</div>
                  <div>Companies</div>
                </div>
              </Tooltip>
            )}
          </SidebarLink>
        )}
        {roleId > MANAGER && (
          <SidebarLink to={"/app/organizations"}>
            <AiOutlineAppstore className="text-3xl" />
            {deviceView >= TABLET && <span className={transitionLink}>Areas</span>}
          </SidebarLink>
        )}
        <SidebarLink to={"/app/locations"}>
          <FaLocationCrosshairs className="text-3xl" />
          {deviceView >= TABLET && <span className={transitionLink}>Locations</span>}
        </SidebarLink>
        {roleId > MANAGER && (
          <SidebarLink to={"/app/users"}>
            <FaUser className="text-3xl" />
            {deviceView >= TABLET && <span className={transitionLink}>Users</span>}
          </SidebarLink>
        )}
      </div>
    </div>
  )
}
